export default __webpack_public_path__ + "static/media/heart-icon.b6779faa.svg";